// extracted by mini-css-extract-plugin
export var $animation_name = "SideBar-module--$animation_name--7029e";
export var Content = "SideBar-module--Content--174e8";
export var Content__header = "SideBar-module--Content__header--e0439";
export var Content__wysiwygContent = "SideBar-module--Content__wysiwygContent--5978f";
export var SideBar = "SideBar-module--SideBar--c389f";
export var SideBar___isVisible = "SideBar-module--SideBar___isVisible--8fa0d";
export var SideBar__closeBtn = "SideBar-module--SideBar__closeBtn--e2c35";
export var SideBar__cover = "SideBar-module--SideBar__cover--497e8";
export var SideBar__cover___isVisible = "SideBar-module--SideBar__cover___isVisible--f90d9";
export var SideBar__isHidden = "SideBar-module--SideBar__isHidden--80112";